import * as angular from 'angular';
import { MobileOS } from 'types/enums';

const MOBILE_BREAKPOINT = 1023;

export function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
}

export function onMobileOnly(callback: () => void) {
    if (isMobile()) {
        callback();
    }
}

export function onDesktopOnly(callback: () => void) {
    if (!isMobile()) {
        callback();
    }
}

export function onScreenResize(mobileCallback: () => void, desktopCallback: () => void) {
    window.addEventListener('resize', () => {
        onMobileOnly(mobileCallback);
        onDesktopOnly(desktopCallback);
    });
}

export const getMobileOS = (): MobileOS => {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
        return MobileOS.Android;
    }

    // iPhone check
    if (navigator.userAgent.toLowerCase().indexOf('iphone') !== -1) {
        return MobileOS.iOS;
    }

    // iPad check
    const isIpad = navigator.userAgent.toLowerCase().indexOf('ipad') !== -1;
    if (!isIpad && navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
        return MobileOS.iOS;
    }
    return MobileOS.Other;
};

// the following is to make this code accessible to unit tests
const module = angular.module('customerPortal.utilities.devices', []);

module.value('getMobileOS', getMobileOS);
